// account-info.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class AccountInfoService {
  private apiUrl = '/onlinetesting/rest/account/accountInfo';

  constructor(
    private httpClient: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) {}

  getAccountInfo(authKey: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-SelectionToken': authKey,
    });

    return this.httpClient
      .get<any>(this.apiUrl, { headers })
      .pipe(catchError((error: HttpErrorResponse) => {
        this.errorHandlerService.handleError(error);
        return throwError(() => error);
      }));
  }
}
